import { apiPost } from '../client';
import type { ResponseBase } from '../types/common';
import type {
  SupportCloseOpenRequest,
  SupportListResponse,
  SupportReplyRequest,
  SupportRequest,
} from '../types/support';

/**
 * support/GetSupports takes the same SupportRequest shape as AddSupport (see
 * api/types/support.ts header). Passing `id` filters to a single ticket, mirroring
 * CostCenter/GetCostCenterById's reuse of the list endpoint's request shape elsewhere
 * in this codebase; leaving it empty returns the full list.
 */
export function getSupports(id?: string): Promise<SupportListResponse> {
  return apiPost<SupportRequest, SupportListResponse>('support/GetSupports', { id });
}

export function addSupport(body: SupportRequest): Promise<SupportListResponse> {
  return apiPost<SupportRequest, SupportListResponse>('support/AddSupport', body);
}

export function replySupport(body: SupportReplyRequest): Promise<ResponseBase> {
  return apiPost<SupportReplyRequest, ResponseBase>('support/ReplySupport', body);
}

export function supportCloseOpen(body: SupportCloseOpenRequest): Promise<ResponseBase> {
  return apiPost<SupportCloseOpenRequest, ResponseBase>('support/SupportCloseOpen', body);
}
